/*
 * Berry — « Afficher plus de produits »
 * Chargement pilote par la VISIBILITE du bouton (IntersectionObserver, natif et econome).
 *  - Le bouton est visible a l'ecran  -> la barre se remplit (1.3s) -> page suivante ajoutee.
 *  - Le bouton n'est plus visible      -> la barre s'arrete (rien ne charge).
 *  Regle footer : au bas de page le bouton est remonte hors ecran -> aucun chargement.
 * Anti-flicker : ne relance pas une barre en cours ; masquage differe (160ms) contre les micro-oscillations.
 * Ajoute aussi les separateurs « Page N » (rendus cote serveur, recuperes avec les cartes).
 */
(function () {
  var FILL_MS = 1300;    // duree de la barre
  var PRE_MARGIN = 500;  // px avant l'entree a l'ecran pour lancer le prechargement
  var BOTTOM_GAP = 4;    // marge px pour detecter le bas absolu de la page

  if (customElements.get('berry-load-more')) return;

  class BerryLoadMore extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.getAttribute('data-section-id');
      this.btn = this.querySelector('.berry-load-more__btn');
      this.fill = this.querySelector('.berry-load-more__fill');
      this.grid = this.closest('results-list')
        ? this.closest('results-list').querySelector('.product-grid')
        : document.querySelector('.product-grid');

      this.loading = false;
      this.rAF = null;
      this.barStart = null;
      this.hideT = null; // timer de masquage differe (anti-flicker)
      this.pf = null; // { page, sig, promise } page prechargee

      // JS actif -> on masque la pagination numerotee et on utilise le bouton.
      document.documentElement.classList.add('berry-lm-on');

      if (!this.grid) return;

      if (this.btn) {
        this.btn.addEventListener('click', () => { this.stopBar(); this.loadMore(); });
      }

      this.hide();
      this.setupObservers();
    }

    disconnectedCallback() {
      if (this.ioPre) this.ioPre.disconnect();
      if (this.ioBar) this.ioBar.disconnect();
      if (this.hideT) clearTimeout(this.hideT);
      this.stopBar();
    }

    setupObservers() {
      var self = this;
      var target = this.btn || this;

      // 1) Prechargement quand le bouton approche (500px avant d'entrer a l'ecran)
      this.ioPre = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) self.prefetchNext();
        }
      }, { root: null, rootMargin: '0px 0px ' + PRE_MARGIN + 'px 0px', threshold: 0 });
      this.ioPre.observe(target);

      // 2) Barre quand le bouton est reellement visible (petite zone morte en bas pour eviter le flicker)
      this.ioBar = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) self.onBtnVisible();
          else self.onBtnHidden();
        }
      }, { root: null, rootMargin: '0px 0px -40px 0px', threshold: 0 });
      this.ioBar.observe(target);
    }

    onBtnVisible() {
      if (this.hideT) { clearTimeout(this.hideT); this.hideT = null; } // annule un masquage transitoire
      if (this.loading) return;
      if (this.rAF) return;                          // barre deja en cours -> ne pas la relancer (evite le reset/flicker)
      if (!this.hasMore()) { this.hide(); return; }
      if (this.atBottom()) { this.hide(); return; }  // securite footer
      this.prefetchNext();
      this.show();
    }

    onBtnHidden() {
      // masquage differe : absorbe les micro-oscillations d'intersection (layout shift pendant le remplissage)
      var self = this;
      if (this.hideT) clearTimeout(this.hideT);
      this.hideT = setTimeout(function () { self.hideT = null; self.hide(); }, 160);
    }

    lastPage() {
      var lp = this.grid ? parseInt(this.grid.getAttribute('data-last-page'), 10) : 1;
      return lp > 0 ? lp : 1;
    }

    currentPage() {
      var max = 1;
      if (!this.grid) return max;
      var items = this.grid.querySelectorAll('[data-page]');
      for (var i = 0; i < items.length; i++) {
        var p = parseInt(items[i].getAttribute('data-page'), 10);
        if (p > max) max = p;
      }
      return max;
    }

    hasMore() { return this.currentPage() < this.lastPage(); }

    // signature de l'etat courant (filtres/tri) hors page/section_id
    sig() {
      var u = new URL(window.location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      u.searchParams.sort();
      return u.search;
    }

    atBottom() {
      return window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - BOTTOM_GAP;
    }

    // recupere et parse une page ; precharge les images ; renvoie les <li> (separateur + cartes)
    fetchPage(n) {
      var url = new URL(window.location.href);
      url.searchParams.set('page', String(n));
      url.searchParams.set('section_id', this.sectionId);
      url.searchParams.sort();
      return fetch(url.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('[ref=grid]') || doc.querySelector('.product-grid');
          if (!g) return [];
          var arr = Array.prototype.slice.call(g.querySelectorAll(':scope > li'));
          // precharge les images en memoire (priorite basse) -> cascade fluide, sans pop
          for (var a = 0; a < arr.length; a++) {
            var imgs = arr[a].querySelectorAll('img');
            for (var b = 0; b < imgs.length; b++) {
              var im = imgs[b];
              im.setAttribute('loading', 'eager');
              im.removeAttribute('data-src');
              var pre = new Image();
              pre.fetchPriority = 'low';
              var ss = im.getAttribute('srcset');
              var sz = im.getAttribute('sizes');
              if (ss) pre.srcset = ss;
              if (sz) pre.sizes = sz;
              var sr = im.getAttribute('src');
              if (sr) pre.src = sr;
            }
          }
          return arr;
        })
        .catch(function () { return []; });
    }

    // precharge la prochaine page si pas deja fait (ou si les filtres ont change)
    prefetchNext() {
      if (this.loading) return;
      var np = this.currentPage() + 1;
      if (np > this.lastPage()) { this.pf = null; return; }
      var s = this.sig();
      if (this.pf && this.pf.page === np && this.pf.sig === s) return;
      this.pf = { page: np, sig: s, promise: this.fetchPage(np) };
    }

    show() {
      if (this.classList.contains('is-on')) return;
      this.classList.add('is-on');
      this.startBar();
    }

    hide() {
      this.classList.remove('is-on');
      this.stopBar();
      this.setFill(0);
    }

    setFill(p) { if (this.fill) this.fill.style.width = p + '%'; }

    startBar() {
      this.stopBar();
      this.barStart = null;
      var self = this;
      var step = function (ts) {
        if (self.barStart == null) self.barStart = ts;
        var p = Math.min(1, (ts - self.barStart) / FILL_MS);
        self.setFill(p * 100);
        if (p < 1) { self.rAF = requestAnimationFrame(step); }
        else { self.rAF = null; self.loadMore(); }
      };
      this.rAF = requestAnimationFrame(step);
    }

    stopBar() { if (this.rAF) { cancelAnimationFrame(this.rAF); this.rAF = null; } }

    async loadMore() {
      if (this.loading || !this.hasMore()) return;
      this.loading = true;
      this.hide();
      var np = this.currentPage() + 1;
      var s = this.sig();
      var items;
      try {
        if (this.pf && this.pf.page === np && this.pf.sig === s) {
          items = await this.pf.promise;             // deja en memoire -> instantane
        } else {
          items = await this.fetchPage(np);          // fallback : fetch a la volee
        }
        this.pf = null;
        if (items && items.length && this.grid) {
          // apparition en cascade : fondu echelonne, uniquement sur les cartes produit
          var d = 0;
          for (var k = 0; k < items.length; k++) {
            var el = items[k];
            if (el && el.classList && el.classList.contains('product-grid__item')) {
              el.classList.add('berry-lm-in');
              el.style.animationDelay = (d * 40) + 'ms';
              d++;
              (function (node) {
                node.addEventListener('animationend', function () {
                  node.classList.remove('berry-lm-in');
                  node.style.animationDelay = '';
                }, { once: true });
              })(el);
            }
          }
          this.grid.append.apply(this.grid, items);
        }
        var clean = new URL(window.location.href);
        clean.searchParams.set('page', String(np));
        history.replaceState({}, '', clean.toString());
      } catch (e) {
        // silencieux : en cas d'echec la pagination numerotee reste disponible
      }
      this.loading = false;
      if (this.hasMore()) { this.prefetchNext(); }
      else { this.remove(); }
    }
  }

  customElements.define('berry-load-more', BerryLoadMore);
})();
